import * as React from 'react'
import { styled, css } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'
import { Trustpilot } from '@ulule/duvet/Trustpilot.tsx'

import * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'
import * as env from '@owl-nest/config'

import { footerBreakpoint } from './constants'

type ManifestoProps = {
  className?: string
  lang: api.Lang
  $lang: api.Lang
}

function ManifestoComponent({ className, lang }: ManifestoProps) {
  return (
    <div className={className}>
      <Trustpilot />

      <About $lang={lang}>
        <plume.styles.heading.XXXXXS>{t('Proudly B Corp since 2015')}</plume.styles.heading.XXXXXS>
        {lang === 'fr' ? <plume.logos.bcorp.FrLogo /> : <plume.logos.bcorp.EnLogo />}

        <plume.Link underlined href={`${env.ULULE_ORIGINS[lang]}/about/ulule/`}>
          {t('Read our manifesto')}
        </plume.Link>
      </About>
    </div>
  )
}

export const Manifesto = styled(ManifestoComponent)`
  ${Trustpilot} {
    padding-top: 32px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    align-items: center;
    display: flex;
    margin: 0 auto;
    width: max-content;
    max-width: 100%;

    ${Trustpilot} {
      padding: 0;
    }
  }
`

const About = styled.div<{ $lang: api.Lang }>`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 16px 0 32px 0;

  ${({ $lang }) => {
    if (footerBreakpoint($lang) === 'laptop') {
      return css`
        @media screen and ${plume.BREAKPOINTS.LAPTOP} {
          margin: 15px 0;
        }
      `
    }

    if (footerBreakpoint($lang) === 'tablet') {
      return css`
        @media screen and ${plume.BREAKPOINTS.TABLET} {
          margin: 15px 0;
        }
      `
    }
  }}

  ${plume.Link} {
    align-items: center;
    display: flex;
    font-size: 13px; // HACK: Irregular font manipulation
    justify-content: center;
    margin-top: 16px;
    text-align: center;
    width: 100%;

    ${({ $lang }) => {
      if (footerBreakpoint($lang) === 'laptop') {
        return css`
          @media screen and ${plume.BREAKPOINTS.LAPTOP} {
            margin: 15px 0;
            width: fit-content;
          }
        `
      }
      if (footerBreakpoint($lang) === 'tablet') {
        return css`
          @media screen and ${plume.BREAKPOINTS.TABLET} {
            margin: 15px 0;
            width: fit-content;
          }
        `
      }
    }}
  }

  ${plume.styles.heading.XXXXXS} {
    color: ${plume.COLORS.PRIMARY_GREY_900};
    text-align: center;
    max-width: 350px;

    @media screen and ${plume.BREAKPOINTS.MOBILE_L} {
      text-align: right;
    }
  }

  ${plume.logos.bcorp.FrLogo}, ${plume.logos.bcorp.EnLogo} {
    margin: 0 15px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    border-left: 1px solid ${plume.COLORS.BORDER_PRIMARY};
    margin: 25px 0;

    ${plume.Link} {
      margin-top: 21px;
    }
  }
`
